import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const Permissions = ProtectedJsonAPI.extend(
  '/permissions',
  {
    permissionSet:  endpoint => endpoint.path('permission_set').method('post').maxConcurrent(15),
  }
)